<h2 mat-dialog-title>Link {{ data.orderLabel }}</h2>

<mat-dialog-content>
  <p class="dialog-subtitle">Search for an existing {{ data.orderLabel | lowercase }} to link.</p>

  <mat-form-field appearance="outline" class="search-field">
    <mat-label>{{ data.orderLabel }}</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input matInput
           [formControl]="orderSearch"
           placeholder="Search by order number or status"
           [matAutocomplete]="autoOrder">
    <button mat-icon-button matSuffix
            *ngIf="orderSearch.value"
            (click)="clearOrder()"
            type="button">
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete #autoOrder="matAutocomplete"
                      [displayWith]="displayOrder.bind(this)"
                      (optionSelected)="onOrderSelected($event.option.value)">
      <mat-option *ngFor="let o of filteredOrders | async" [value]="o">
        <span class="option-number">#{{ o.number }}</span>
        <span class="option-meta"> — {{ o.status }}{{ o.date ? ' · ' + (o.date | date:'mediumDate') : '' }}{{ o.totalAmount ? ' · ' + (o.totalAmount | currency) : '' }}</span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <div *ngIf="selectedOrder" class="selected-preview">
    <mat-icon>check_circle</mat-icon>
    <span>Selected: <strong>#{{ selectedOrder.number }}</strong> ({{ selectedOrder.status }})</span>
  </div>

  <p *ngIf="errorMessage" class="error-message">{{ errorMessage }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button"
          [disabled]="!selectedOrder || isLinking"
          (click)="link()">
    <mat-spinner *ngIf="isLinking" diameter="18" class="inline-spinner"></mat-spinner>
    {{ isLinking ? 'Linking…' : 'Link' }}
  </button>
</mat-dialog-actions>
